import Vue from 'vue'
import VueCookies from 'vue-cookies'
import VueSignaturePad from 'vue-signature-pad'
import VueFilterDateParse from '@vuejs-community/vue-filter-date-parse'
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format'
import VueObserveVisibility from 'vue-observe-visibility'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false
Vue.use(VueCookies)
Vue.use(VueSignaturePad)
Vue.use(VueFilterDateParse)
Vue.use(VueFilterDateFormat)
Vue.use(VueObserveVisibility)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
